var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout',{style:(Object.assign({}, _vm.defaultWrapStyles, _vm.wrapStyles))},[_c('a-layout-content',{style:(Object.assign({}, _vm.defaultStyles, _vm.styles))},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }